import "client-only";
import { fetcher } from "src/utils/fetcher";
import useSWR from "swr";

function useCountOrderTabs(params) {
  return useSWR(
    !!params?.warehouse
      ? {
          path: `/api/v1/orders/count`,
          method: "GET",
          params,
        }
      : null,
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnMount: true,
    },
  );
}

export default useCountOrderTabs;
